/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Row, Col, Input } from 'reactstrap';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import {
  updateOrderDetailInfoAction,
  setIsShowCoupon,
} from '../../../actions/order';

import imgCross from '../../../assets/img/icon_cross_r.png';
import imgCross2 from '../../../assets/img/icon_cross_r@2x.png';

class Order20Coupon extends React.Component {
  static propTypes = {
    orderPriceBreakdownDetail: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
    isShowCoupon: PropTypes.bool.isRequired,
    setIsShowCoupon: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      isValidCouponCode: true,
      isShowValidCouponCode: false,
      CouponStyle: s2.couponHide,
      code: '',
    };
    this.onClickShowCoupon = this.onClickShowCoupon.bind(this);
    this.onClickHideCoupon = this.onClickHideCoupon.bind(this);
    this.onClickClearCode = this.onClickClearCode.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Checking coupon response from server
    if (typeof nextProps.orderPriceBreakdownDetail.coupon !== 'undefined') {
      if (
        this.props.orderPriceBreakdownDetail.coupon !==
        nextProps.orderPriceBreakdownDetail.coupon
      ) {
        this.setState({
          isValidCouponCode: nextProps.orderPriceBreakdownDetail.coupon.valid,
        });
        if (nextProps.orderPriceBreakdownDetail.coupon.valid) {
          if (!this.state.isShowValidCouponCode) {
            this.onClickHideCoupon();
            this.setState({ isShowValidCouponCode: true });
          }
        } else {
          this.props.updateOrderDetailInfoAction('coupon_code', null, null);
        }
      }
    }
  }

  onClickShowCoupon() {
    this.props.setIsShowCoupon(true);
  }

  onClickHideCoupon() {
    this.props.setIsShowCoupon(false);
    // delay the anime
    this.setState({ CouponStyle: s2.removeCoupon }, () => {
      setTimeout(() => {
        this.setState({ CouponStyle: s2.couponHide });
      }, 500);
    });
  }

  onClickClearCode() {
    this.setState({ code: '' });
  }

  render() {
    return (
      <div>
        <Row className={s2.orderPricingCoupon}>
          <Col
            className={s2.orderFunctionText}
            onClick={() => {
              if (!this.state.isShowValidCouponCode) {
                this.onClickShowCoupon();
              }
            }}
          >
            {this.props.modelDataText.order_promo_code_if_any_title}
          </Col>
        </Row>
        <Row
          className={`${
            this.props.isShowCoupon ? s2.addCoupon : this.state.CouponStyle
          }`}
        >
          <Col lg="5" xs="5">
            <Input
              value={this.state.code}
              onChange={e => {
                this.setState({ code: e.target.value });
              }}
              placeholder={this.props.modelDataText.order_promo_code_input}
            />
            <span
              className={s2.couponCrossButton}
              role="button"
              tabIndex={0}
              onClick={() => {
                this.onClickClearCode();
              }}
              onKeyPress={() => {}}
            >
              <img
                srcSet={`${imgCross} 1x, ${imgCross2} 2x`}
                width="24"
                height="24"
                alt="cross"
              />
            </span>
            {!this.state.isValidCouponCode ? (
              <p className={`${s.globalTextRed} ${s.globalFontNormal}`}>
                {this.props.modelDataText.order_promo_input_warning}
              </p>
            ) : (
              ''
            )}
          </Col>
          <Col lg="7" xs="7" className={s2.buttonLeft}>
            <button
              className={`${s.quotingOptionItemButton} ${s.button} ${s.outlined}
              ${s.secondary} ${s.small} ${s.dialog} ${s2.buttonStyle}`}
              onClick={() => {
                this.props.updateOrderDetailInfoAction(
                  'coupon_code',
                  null,
                  null,
                );
                this.onClickHideCoupon();
              }}
            >
              {this.props.modelDataText.order_promo_code_cancel_button}
            </button>
            <button
              className={`${s.button} ${s.secondary} ${s2.buttonStyle}`}
              onClick={() => {
                this.props.updateOrderDetailInfoAction(
                  'coupon_code',
                  null,
                  this.state.code,
                );
              }}
            >
              {this.props.modelDataText.order_promo_code_confirm_button}
            </button>
          </Col>
        </Row>
        <br />
        {this.state.isShowValidCouponCode ? (
          <Row>
            <Col lg="6" xs="6">
              <span
                role="button"
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onClick={() => {
                  this.props.updateOrderDetailInfoAction(
                    'coupon_code',
                    null,
                    null,
                  );
                  this.setState({ isShowValidCouponCode: false });
                }}
                onKeyPress={() => {}}
              >
                <img
                  srcSet={`${imgCross} 1x, ${imgCross2} 2x`}
                  width="24"
                  height="24"
                  alt="cross"
                />
                {this.props.modelDataText.order_promo_code_title}
              </span>
            </Col>
            <Col lg="6" xs="6" style={{ textAlign: 'right' }}>
              {typeof this.props.orderPriceBreakdownDetail.coupon !==
              'undefined'
                ? this.props.orderPriceBreakdownDetail.coupon.message
                : ''}
            </Col>
          </Row>
        ) : (
          ''
        )}
      </div>
    );
  }
}
const mapState = state => ({
  isToggleOn: state.order.isToggleOn,
  isShowCoupon: state.order.isShowCoupon,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
});

const mapDispatch = {
  updateOrderDetailInfoAction,
  setIsShowCoupon,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order20Coupon),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order20Coupon/Order20Coupon.js